export default __webpack_public_path__ + "static/media/Icons-41.83c3f664.png";